module.exports = __webpack_public_path__ + "media/tablet.44b08650.mp4";